/**
 * Known theme preset names. Composite names follow the pattern `{client}_{variant}`.
 * The trailing `(string & {})` keeps the union open so future names don't cause type errors.
 */
export type DmsThemeName =
    | 'panther_default'  // Practice Panther – primary blue (#162FEF)
    | 'panther_rose'  // Practice Panther – primary blue (#162FEF)
    | 'default'
    | 'brand'
    | 'teal'
    | 'rose'
    | 'purple'
    | 'amber'
    | 'lolly'
    | (string & {});

/**
 * Maps composite theme preset names to their CSS class.
 * Add new client themes here — no other file needs to change.
 */
export const DMS_THEME_CLASS_MAP: Record<string, string> = {
    panther_default: 'theme-panther',
    panther_rose   : 'theme-rose',
};

export class DmsClientTheme {
    name: DmsThemeName = 'default';
    /** Google Font family loaded and applied inside the Shadow DOM. e.g. 'Poppins' */
    fontFamily?: string = null;
    /** CSS border-radius for all Material button variants. e.g. '4px' */
    buttonBorderRadius?: string = null;
}
